import type {UserEventSpec, UserEventStruct} from '@cohort/shared/schema/apps/userEvent';
import {z} from 'zod';

export const CohortXpsVisitedPropertiesSchema = z.object({});
export type CohortXpsVisitedProperties = z.infer<typeof CohortXpsVisitedPropertiesSchema>;

export type CohortXpsVisitedEventStruct = UserEventStruct<
  'cohort.user.xps-visited',
  CohortXpsVisitedProperties
>;

export const CohortXpsVisitedEventSpec: UserEventSpec<CohortXpsVisitedEventStruct> = {
  id: 'cohort.user.xps-visited',
  propertiesSchema: CohortXpsVisitedPropertiesSchema,
};
